import { createAsyncThunk } from '@reduxjs/toolkit';
import { IN_DEVELOPMENT } from '../constants';

import debug from '../utils/debug';
import setLocalValue from '../utils/setLocalValue';
// import { clearOffers } from '../slices/offers';
import { clearProfile } from '../slices/profile';
import { RedcatApiHandler } from 'polygon-utils';
import { syncMember } from './syncMember';

export const signOut = createAsyncThunk('signOut', async (_data: undefined, { dispatch }) => {
  debug('sign out');

  await RedcatApiHandler.fetch({
    method: 'GET',
    path: '/auth/logout',
  }).finally(() => {
    if (IN_DEVELOPMENT) {
      setLocalValue('memberAuthToken', undefined);
    }

    dispatch(syncMember());
    // dispatch(clearOffers(null));
    dispatch(clearProfile());
  });
});
